import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchPendingSubstitutions, approveSubstitution, rejectSubstitution } from './api';

export function usePendingSubstitutions(enabled: boolean) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.pharmacy.substitutionsPending(), branchVersion],
    queryFn: fetchPendingSubstitutions,
    enabled,
  });
}

function useInvalidateSubstitutionQueries() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: keys.pharmacy.substitutionsPending() });
    queryClient.invalidateQueries({ queryKey: keys.pharmacy.substitutionsCount() });
    // The bell lists each pending request; a decision removes it there too.
    queryClient.invalidateQueries({ queryKey: keys.notifications.feed() });
  };
}

export function useApproveSubstitution() {
  const invalidate = useInvalidateSubstitutionQueries();
  return useMutation({
    mutationFn: (id: number) => approveSubstitution(id),
    onSuccess: invalidate,
  });
}

export function useRejectSubstitution() {
  const invalidate = useInvalidateSubstitutionQueries();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string }) => rejectSubstitution(id, reason),
    onSuccess: invalidate,
  });
}
